var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NewBlockButtonList"},_vm._l((_vm.blocktypes),function(blocktype){return _c('ce-new-block-button',{key:blocktype,staticClass:"NewBlockButtonList-Item",attrs:{"type":blocktype,"on-click":_vm.onButtonClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }